// extracted by mini-css-extract-plugin
module.exports = {"menu":"index_menu_n4_ft"};